// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpTabsHero-cls1_Yhu","cls2":"LoswpTabsHero-cls2_Z45 LoswpTabsHero-cls1_Yhu","offset-v2":"LoswpTabsHero-offset-v2_IPx"};